<template>
  <div class="mine-filter-box">
    <Search></Search>
    <div class="line"></div>
    <MyExecution :onlyReal="onlyReal"></MyExecution>
    <Status v-if="taskModeCheck.key == 3"></Status>
    <TaskType></TaskType>
    <ProjectList :uid="uid"></ProjectList>
    <ExportData :uid="uid"></ExportData>
    <ModCheck></ModCheck>
  </div>
</template>
<script>
import Search from './search'
import MyExecution from './myExecution'
import Status from './status'
import TaskType from './taskType'
import ProjectList from './projectList'
import ModCheck from './modCheck'
import ExportData from '@/components/taskFilterBox/exportData'
import { mapState } from 'vuex'
export default {
  props: ['onlyReal', 'uid'],
  components: {
    Search,
    MyExecution,
    Status,
    TaskType,
    ProjectList,
    ModCheck,
    ExportData
  },
  computed: {
    ...mapState('mine/mine', {
      taskModeCheck: state => state.taskModeCheck
    })
  },
  data() {
    return {

    }
  },
  methods: {

  }
}
</script>
<style lang="scss">
@import "@/assets/scss/mixin.scss";
.mine-filter-box {
  margin-right: 27px;
  display: flex;
  align-items: center;
  .fadeDown-enter-active {
    animation: fadeInUpBig 1s;
  }
  .fadeDown-leave-to {
    animation: fadeOutDownBig 1s;
  }
  .line {
    height: 16px;
    width: 1px;
    @include bgColorOpacity(.16);
    margin-left: 8px;
    margin-right: 16px;
  }
  .el-dropdown .el-dropdown-link {
    @include fontColorOpacity(.6);
    font-size: 14px;
    font-weight: 400;
    i {
      @include fontColorOpacity(.6);
      font-weight: 400;
      margin-right: 9px;
    }
  }
  .filter-status {
    margin-left: 8px;
  }
  .el-dropdown-link {
    padding:8px;
  }
}
</style>
